"use strict";require('@ebay/skin/icon-button');